module.exports = "/images/43eb46a0b7acb58001558dd07b3b0ba6.png";